import { z } from 'zod'

export const ADMINFORMSASSIGNMENTSGET_CONTRACT_VERSION = '1.0.0' as const
export const adminFormsAssignmentsGetResponseSchema = z.unknown()
export type AdminFormsAssignmentsGetResponse = z.infer<typeof adminFormsAssignmentsGetResponseSchema>
